/**
 *
 * Input
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import InputWrapper from './styles/InputWrapper';
import InputElem from './styles/InputElem';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

class Input extends React.PureComponent {
  constructor() {
    super();

    this.setValue = this.setValue.bind(this);
    this.showPassword = this.showPassword.bind(this);

    this.state = {
      value: ''
    };

  }

  setValue(event){
    this.setState({ value: event.target.value });
    this.props.sendDataCallback(event.target.value);
  }

  showPassword(){
    this.props.sendPasswordShowCallback();
  }

  render() {
    const { label, type, isPassword, passwordShow, isRequired, showError } = this.props;

    const { value } = this.state;

    return (
      <InputWrapper className="input-wrapper">
        <p>{label}</p>
        <InputElem value={value} type={type} onChange={this.setValue}/>
        {showError ? (
        <p className="input-error">{label} is required.</p>
        ) : ("")}
        
        { isPassword ? (
          <a className="passwordIconShowHide">
            { !passwordShow ? (
              <VisibilityIcon onClick={this.showPassword} fontSize="large"/>
            ) : (
              <VisibilityOffIcon onClick={this.showPassword} fontSize="large"/>
            ) }
          </a>
        ) : (
          ""
        ) }
      </InputWrapper>
    );
  }
}

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  isPassword: PropTypes.bool,
  passwordShow: PropTypes.bool,
  sendDataCallback: PropTypes.func,
  sendPasswordShowCallback: PropTypes.func,
  isRequired: PropTypes.bool,
  showError: PropTypes.bool,
};

export default Input;
